import { formatHoursToDate } from 'helpers/number'

const getDayTimelineItems = () =>
	new Array(23).fill(null).map((_, index) => formatHoursToDate(index + 1))

export default getDayTimelineItems
